import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constant";
import { showLoaderAction, hideLoaderAction } from "./loaderAction";
import { showToast } from "./toastAction";
import { uploadImages } from "../../utils/uploadFiles";

const addOurWork = (data, history) => async (dispatch) => {
    dispatch(showLoaderAction());

    const ourWorkData = { ...data };

    for (let key in ourWorkData) {
        if (ourWorkData[key] instanceof File) {
            const image = await uploadImages([ourWorkData[key]]);
            ourWorkData[key] = image[0] ?? "";
        }
        if (Array.isArray(ourWorkData[key]) && ourWorkData[key][0] instanceof File) {
            const image = await uploadImages(ourWorkData[key]);
            ourWorkData[key] = image[0] ?? "";
        }
    }

    const res = await api("post", Constants.END_POINT.OUR_WORK, ourWorkData);
    if (res.success) {
        history.go(-1);
        dispatch(showToast({ severity: "success", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

const fetchOurWorks = () => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.OUR_WORKS);
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.OUR_WORK_LIST,
                payload: res.data,
            });
        }
    }
    dispatch(hideLoaderAction());
};

const fetchOurWorkDetails = (id) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.OUR_WORK + id);
    if (res.success) {
        dispatch(hideLoaderAction());
        if (res.data) {
            dispatch({
                type: types.OUR_WORK_DETAILS,
                payload: res.data,
            });
        }
    }
    dispatch(hideLoaderAction());
};

const updateWork = (id, data, history) => async (dispatch) => {
    dispatch(showLoaderAction());

    const ourWorkData = { ...data };

    for (let key in ourWorkData) {
        if (ourWorkData[key] instanceof File) {
            const image = await uploadImages([ourWorkData[key]]);
            ourWorkData[key] = image[0] ?? "";
        }
        if (Array.isArray(ourWorkData[key]) && ourWorkData[key][0] instanceof File) {
            const image = await uploadImages(ourWorkData[key]);
            ourWorkData[key] = image[0] ?? "";
        }
    }

    const res = await api("put", Constants.END_POINT.OUR_WORK + id, ourWorkData);
    if (res.success) {
        history.go(-1);
        dispatch(showToast({ severity: "success", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

const deleteWork = (id) => async (dispatch) => {
    dispatch(showLoaderAction());

    const res = await api("delete", Constants.END_POINT.OUR_WORK + id);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(fetchOurWorks());
    }
    dispatch(hideLoaderAction());
};

const addProduct = (data, setVisible, resetForm) => async (dispatch) => {
    dispatch(showLoaderAction());

    const productData = { ...data };

    const image = await uploadImages([productData.image]);
    productData.image = image[0] ?? "";

    const res = await api("post", Constants.END_POINT.ADD_PRODUCT, productData);
    if (res.success) {
        setVisible(false);
        resetForm();
        dispatch(fetchOurWorkDetails(productData.ourWork));
        dispatch(showToast({ severity: "success", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

const fetchProductDetails = (id) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.OUR_WORK + id);
    if (res.success) {
        dispatch(hideLoaderAction());
        if (res.data) {
            dispatch({
                type: types.OUR_WORK_DETAILS,
                payload: res.data,
            });
        }
    }
    dispatch(hideLoaderAction());
};

const updateProduct = (id, data, setVisible, resetForm) => async (dispatch) => {
    dispatch(showLoaderAction());

    const productData = { ...data };

    if (productData.image instanceof File) {
        const image = await uploadImages([productData.image]);
        productData.image = image[0] ?? "";
    }

    const res = await api("put", Constants.END_POINT.PRODUCT + id, productData);
    if (res.success) {
        setVisible(false);
        resetForm();
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(fetchOurWorkDetails(productData.ourWork));
    }
    dispatch(hideLoaderAction());
};

const deleteProduct = (id, workId) => async (dispatch) => {
    dispatch(showLoaderAction());

    const res = await api("delete", Constants.END_POINT.PRODUCT + id);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(fetchOurWorkDetails(workId));
    }
    dispatch(hideLoaderAction());
};

export { addOurWork, fetchOurWorks, fetchOurWorkDetails, updateWork, deleteWork, addProduct, fetchProductDetails, updateProduct, deleteProduct };
